export default "__VITE_ASSET__CvYC5WUm__"